import $ from 'jquery';

function menu() {
	const $menu = $('.c-off-canvas_menu'),
				$submenuToggle = $menu.find('.submenu-toggle');

	if( !$submenuToggle ) return;

	$submenuToggle.each(function() {
		let $id = $(this).attr('id');

		$(this).attr('id', `toggle-${$id}`);
	});
}

export { menu };